document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('.article-page').length > 0 && document.querySelectorAll('.article-page a').length > 0) {
    document.querySelectorAll('.article-page a').forEach((a) => {
      let isExternalLink = isExternalReplace(a.getAttribute('href'));
      if (isExternalLink) {
        a.setAttribute('target', '_blank')
      }
    });
  }
});

function isExternalReplace(url) {
  if (url.includes("http")) {
    const domain = (url) => url.replace('http://','').replace('https://','').split('/')[0];       
    return domain(location.href) !== domain(url);
  } else {
    return false;
  }
}